/* Mix & match builder (sections/mix-builder.liquid), Channel Canna 2026-10-08.
   Each row = one chosen pack size (chip) + a quantity. Nothing starts
   selected. "Add to cart" posts every row with qty > 0 to /cart/add.js in
   one request, then refreshes the header count and opens the cart drawer
   through the header's [data-cart-open] trigger (theme.js re-fetches and
   re-renders the drawer on that click). Ids, prices and pack sizes come
   from the chips' data attributes, rendered by Liquid from variant data. */
(function () {
  'use strict';

  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function analytics(name, props) {
    try { document.dispatchEvent(new CustomEvent('cc:analytics', { detail: { name: name, props: props || {} } })); } catch (e) {}
  }

  function init(root) {
    if (!root || root.dataset.mxBound || !root.hasAttribute('data-mx-open')) return;
    root.dataset.mxBound = '1';

    var max = parseInt(root.dataset.max, 10) || 20;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' });
    } catch (e) {
      fmt = { format: function (v) { return '$' + v.toFixed(2); } };
    }
    var money = function (cents) { return fmt.format(cents / 100); };

    var addBtn = root.querySelector('[data-mx-add]');
    var msg = root.querySelector('[data-mx-msg]');
    var elPacks = root.querySelector('[data-mx-packs]');
    var elCans = root.querySelector('[data-mx-cans]');
    var elTotal = root.querySelector('[data-mx-total]');
    var busy = false;

    var rows = Array.prototype.map.call(root.querySelectorAll('[data-mx-row]'), function (el) {
      return {
        el: el,
        handle: el.dataset.handle,
        chips: Array.prototype.slice.call(el.querySelectorAll('[data-mx-chip]')),
        qtyEl: el.querySelector('[data-mx-qty]'),
        subEl: el.querySelector('[data-mx-sub]'),
        chip: null,
        qty: 0
      };
    });

    function say(text) { if (msg) msg.textContent = text || ''; }

    function chipOk(c) { return c && !c.hasAttribute('data-soldout'); }

    function renderRow(r) {
      r.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === r.chip)); });
      if (r.qtyEl) r.qtyEl.textContent = String(r.qty);
      r.el.classList.toggle('is-active', r.qty > 0 && !!r.chip);
      if (r.subEl) {
        r.subEl.textContent = (r.qty > 0 && r.chip)
          ? r.qty + ' × ' + r.chip.dataset.pack + ' · ' + money(r.qty * parseInt(r.chip.dataset.price, 10))
          : '';
      }
    }

    function render() {
      var packs = 0, cans = 0, total = 0;
      rows.forEach(function (r) {
        renderRow(r);
        if (r.qty > 0 && chipOk(r.chip)) {
          packs += r.qty;
          cans += r.qty * (parseInt(r.chip.dataset.cans, 10) || 0);
          total += r.qty * parseInt(r.chip.dataset.price, 10);
        }
      });
      if (elPacks) elPacks.textContent = plural(packs, 'pack', 'packs');
      if (elCans) elCans.textContent = plural(cans, 'can', 'cans');
      if (elTotal) elTotal.textContent = money(total);
      if (addBtn) addBtn.setAttribute('aria-disabled', String(packs === 0 || busy));
      return packs;
    }

    rows.forEach(function (r) {
      r.chips.forEach(function (c) {
        c.addEventListener('click', function () {
          if (!chipOk(c)) { say(c.dataset.pack + ': ' + (c.querySelector('.mx-chip__price') || {}).textContent); return; }
          r.chip = c;
          if (r.qty === 0) r.qty = 1;
          say('');
          render();
        });
      });
      var dec = r.el.querySelector('[data-mx-dec]');
      var inc = r.el.querySelector('[data-mx-inc]');
      if (inc) inc.addEventListener('click', function () {
        if (!r.chip) {
          /* No pack chosen yet: take this row's smallest available pack
             (the 4-pack, the theme's default pack). Never a formula choice:
             the shopper picked this row. */
          var first = r.chips.filter(chipOk).sort(function (a, b) {
            return (parseInt(a.dataset.cans, 10) || 0) - (parseInt(b.dataset.cans, 10) || 0);
          })[0];
          if (!first) { say((r.chips[0] && r.chips[0].querySelector('.mx-chip__price') || {}).textContent || ''); return; }
          r.chip = first;
          say((root.dataset.msgPicked || '').replace('[pack]', first.dataset.pack));
        } else {
          say('');
        }
        r.qty = Math.min(max, r.qty + 1);
        render();
      });
      if (dec) dec.addEventListener('click', function () {
        if (r.qty === 0) return;
        r.qty -= 1;
        say('');
        render();
      });
    });

    function setCount(cart) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      Array.prototype.forEach.call(countEls, function (el) {
        el.textContent = String(cart.item_count);
        el.hidden = cart.item_count === 0;
      });
    }

    function openDrawer() {
      var t = document.querySelector('[data-cart-open]');
      if (t) { t.click(); } else { window.location.href = '/cart'; }
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      if (busy) return;
      var items = rows.filter(function (r) { return r.qty > 0 && chipOk(r.chip); }).map(function (r) {
        return { id: parseInt(r.chip.dataset.id, 10), quantity: r.qty };
      });
      if (!items.length) { say(root.dataset.msgEmpty || ''); return; }

      busy = true;
      addBtn.classList.add('is-busy');
      addBtn.setAttribute('aria-busy', 'true');
      render();
      say('');

      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            var err = new Error('add');
            err.description = data && (data.description || data.message);
            throw err;
          }
          return data;
        });
      }).then(function () {
        analytics('mix_add', { lines: items.length, packs: items.reduce(function (s, i) { return s + i.quantity; }, 0) });
        rows.forEach(function (r) { r.qty = 0; r.chip = null; });
        say(root.dataset.msgAdded || '');
        return fetch(root_url + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(setCount)
          .catch(function () {})
          .then(openDrawer);
      }).catch(function (err) {
        analytics('mix_add', { outcome: 'error' });
        say((err && err.description) || root.dataset.msgError || '');
      }).then(function () {
        busy = false;
        addBtn.classList.remove('is-busy');
        addBtn.removeAttribute('aria-busy');
        render();
      });
    });

    render();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mx]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
